import { logError } from 'setup/logger/logError';
import { logInfo } from 'setup/logger/logInfo';
import { LogLevel } from 'shared/types/logger';
import { collectServiceWorkerDiagnostics } from './collectServiceWorkerDiagnostics';
import { classifyServiceWorkerFailure, ServiceWorkerFailureKind, toServiceWorkerDiagnosticsLog } from './model';
import { requestServiceWorkerUpdate } from '../requestServiceWorkerUpdate';

/**
 * Logs why the selected project's data could not be loaded, with the worker's
 * snapshot (download state of every entity included), and resolves with the
 * cause it found. An outdated worker is asked to update. A reason that is a
 * state of the account rather than a failure of the app is logged as info.
 */
export async function reportProjectDataLoadingFailure(
  reason: string,
  details: Record<string, unknown>,
  logLevel: LogLevel = LogLevel.ERROR
): Promise<ServiceWorkerFailureKind> {
  const diagnostics = await collectServiceWorkerDiagnostics();
  const failureKind = classifyServiceWorkerFailure(diagnostics);
  const log = logLevel === LogLevel.INFO ? logInfo : logError;
  log(`Project data could not be loaded: ${reason}`, {
    reason,
    failureKind,
    ...details,
    ...toServiceWorkerDiagnosticsLog(diagnostics),
  });
  if (failureKind === ServiceWorkerFailureKind.outdatedWorker) {
    requestServiceWorkerUpdate(`project-data-loading: ${reason}`);
  }
  return failureKind;
}
